var x = /* @__PURE__ */ ((m) => (m.xs = "xs", m.sm = "sm", m.md = "md", m.lg = "lg", m.xl = "xl", m["2xl"] = "2xl", m))(x || {});
const a = {
  xs: {
    name: "extra-small",
    alias: "xs",
    minWidth: 0,
    maxWidth: 639,
    sizeIndex: 0
  },
  sm: {
    name: "small",
    alias: "sm",
    minWidth: 640,
    maxWidth: 767,
    sizeIndex: 1
  },
  md: {
    name: "medium",
    alias: "md",
    minWidth: 768,
    maxWidth: 1023,
    sizeIndex: 2
  },
  lg: {
    name: "large",
    alias: "lg",
    minWidth: 1024,
    maxWidth: 1279,
    sizeIndex: 3
  },
  xl: {
    name: "extra-large",
    alias: "xl",
    minWidth: 1280,
    maxWidth: 1535,
    sizeIndex: 4
  },
  "2xl": {
    name: "extra-extra-large",
    alias: "2xl",
    minWidth: 1536,
    maxWidth: 9999,
    sizeIndex: 5
  }
}, i = () => {
  for (const m in a)
    if (window.matchMedia(`(min-width: ${a[m].minWidth}px) 
              and (max-width: ${a[m].maxWidth}px)`).matches)
      return a[m];
  return a.md;
};
export {
  x as ViewportSizeAlias,
  a as ViewportSizes,
  i as getCurrentViewportSize
};
//# sourceMappingURL=viewport.es.js.map
